import { ChildBase, GeneralJsonTypeBase } from '@unicorn/sdui';
import { RelatedTickets } from '../../related-tickets';

export const stages = {
  class: 'class', // Запрос формы выбора класса заявки
  type_plus: 'type_plus', // Запрос формы выбора типа заявки после выбора класса
  custom_fields: 'custom_fields', // Запрос формы стандартных послей после выбора типа заявки
  ticket: 'ticket', // Запрос формы существующей заявки
} as const;

export type Stages = (typeof stages)[keyof typeof stages];

export type GetFieldsPayload = {
  stage: Stages;

  /**
   * - если stage === class, то data не посылается
   * - если stage === type_plus, то в data посылается 'inner' или 'client' (выбранный класс)
   * - если stage === custom_fields, то в data посылается id выбранного типа заявки
   * - если stage === ticket, то в data посылается id заявки
   */
  data?: string | number;
};

export type GetFieldsResponse = {
  schema: GeneralJsonTypeBase | ChildBase[];
  ticket: TicketData;
};

export type TicketData = {
  id: number;
  number: string;
  channels: Channels;
  is_paid: boolean;
  status: string;
  class: string;
  related: RelatedTickets;
};

export type Channels = {
  employees: Channel;
  resident: Channel;
  support?: Channel;
};

export type Channel = {
  id: number;
  is_hidden?: boolean;
  title: string;
  can_write_in_ticket_resident_chat?: boolean;
};

export type CreateTicketPayload = {
  fields: TicketPayloadField[];
};

export type UpdateTicketPayload = {
  id: number | string;
  fields: TicketPayloadField[];
};

export type TicketPayloadField = {
  [key: string]: PayloadFieldValue;
};

export type PayloadFieldValue = string | number | boolean | (string | number | boolean)[];

export type CreateUpdateTicketResponse = {
  ticket: { id: number };
};
